<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
        </section>

        <section class="dp-right">
            <div class="page-head">
                <div class="page-head__info">
                    <h3 class="page-head__title">学生评价报告</h3>
                    <span class="page-head__desc">查看生成记录，按学期/周次生成 Word 报告</span>
                </div>
                <el-button type="success" icon="el-icon-document" @click="openReportDialog">
                    生成报告
                </el-button>
            </div>

            <div class="toolbar-filter-bar">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form :inline="true" :model="filters" class="toolbar-filter-form">
                    <div class="toolbar-filter-fields">
                    <el-form-item label="学生姓名">
                        <el-input v-model="filters.studentName" placeholder="学生姓名" clearable
                            class="toolbar-field-w-sm"></el-input>
                    </el-form-item>
                    <el-form-item label="生成人">
                        <el-input v-model="filters.teacherName" placeholder="生成人" clearable
                            class="toolbar-field-w-sm"></el-input>
                    </el-form-item>
                    <el-form-item label="文件名">
                        <el-input v-model="filters.fileName" placeholder="文件名" clearable
                            class="toolbar-field-w-md"></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="filters.status" placeholder="全部" clearable class="toolbar-field-w-sm">
                            <el-option label="全部" :value="null"></el-option>
                            <el-option label="待处理" :value="0"></el-option>
                            <el-option label="生成中" :value="1"></el-option>
                            <el-option label="已生成" :value="2"></el-option>
                            <el-option label="失败" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间">
                        <el-date-picker v-model="filters.createTimeRange" type="daterange"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                            class="toolbar-field-w-daterange" clearable></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button v-for="item in buttonList.filter(b => b.Func === 'handleQuery')" :key="item.id"
                            type="primary" size="small" icon="el-icon-search" @click="handleQuery">{{ item.name || '查询' }}</el-button>
                    </el-form-item>
                    </div>
                    <div class="toolbar-filter-actions">
                        <el-button v-for="item in buttonList.filter(b => b.Func === 'handleDel')" :key="item.id"
                            size="small" type="danger" icon="el-icon-delete" @click="handleDel">{{ item.name || '删除' }}</el-button>
                    </div>
                </el-form>
            </el-col>
            </div>

            <div class="tbl-scroll-host">
            <el-table :data="list" v-loading="loading" style="width: 100%;"
                @selection-change="handleSelectionChange" height="100%">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="DepartmentName" label="班级" min-width="100"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="StudentName" label="学生" min-width="90"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="TeacherName" label="生成人" min-width="90"
                    show-overflow-tooltip></el-table-column>
                <el-table-column label="评价周期" min-width="180">
                    <template slot-scope="scope">
                        {{ formatDate(scope.row.StartTime) }} ~ {{ formatDate(scope.row.EndTime) }}
                    </template>
                </el-table-column>
                <el-table-column prop="FileName" label="文件名" min-width="220" show-overflow-tooltip></el-table-column>
                <el-table-column prop="ExportFormatText" label="格式" width="72" align="center"></el-table-column>
                <el-table-column prop="FileSizeText" label="大小" width="100"></el-table-column>
                <el-table-column label="状态" width="100">
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.Status === 3 && scope.row.ErrorMessage"
                            :content="scope.row.ErrorMessage" placement="top">
                            <el-tag :type="statusTagType(scope.row.Status)" size="small">
                                {{ scope.row.StatusText || statusText(scope.row.Status) }}
                            </el-tag>
                        </el-tooltip>
                        <el-tag v-else :type="statusTagType(scope.row.Status)" size="small">
                            {{ scope.row.StatusText || statusText(scope.row.Status) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="存储" width="80">
                    <template slot-scope="scope">{{ storageTypeText(scope.row.StorageType) }}</template>
                </el-table-column>
                <el-table-column label="创建时间" width="160">
                    <template slot-scope="scope">{{ formatDateTime(scope.row.CreateTime) }}</template>
                </el-table-column>
                <el-table-column label="操作" width="160" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" @click="openReportViewFromRow(scope.row)">查看</el-button>
                        <el-button v-for="item in buttonList.filter(b => b.Func === 'handleDownload')" :key="item.id"
                            type="text" :disabled="!scope.row.CanDownload" @click="handleDownload(scope.row)">
                            {{ item.name || '下载' }}
                        </el-button>
                        <el-button v-for="item in buttonList.filter(b => b.Func === 'handleDel')"
                            :key="'row-del-' + item.id" type="text" class="ser-op-del"
                            @click="handleDelRow(scope.row)">{{ item.name || '删除' }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            </div>

            <div class="pagination-wrap">
                <el-pagination layout="total, prev, pager, next, jumper" :current-page="page"
                    :page-size="pageSize" :total="total" @current-change="loadList"></el-pagination>
            </div>
        </section>

        <!-- 生成报告弹窗 -->
        <el-dialog :visible.sync="reportDialogVisible" width="720px" top="8vh"
            custom-class="ser-report-dialog" :close-on-click-modal="false" @closed="resetReportDialog">
            <div slot="title" class="ser-dialog-title">
                <span class="ser-dialog-title__icon"><i class="el-icon-document"></i></span>
                <div class="ser-dialog-title__text">
                    <span class="ser-dialog-title__main">{{ reportDialogTitle }}</span>
                    <span class="ser-dialog-title__sub">选择学生与评价周期，可查看报告或生成 Word</span>
                </div>
            </div>

            <div class="ser-dialog-body">
                <el-form :model="reportForm" label-width="80px" size="small" class="ser-dialog-form">

                    <div class="ser-form-block">
                        <div class="ser-form-block__head">选择对象</div>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="班级" required>
                                    <el-select v-model="reportForm.classId" filterable placeholder="请选择班级"
                                        :loading="classLoading" @change="onReportClassChange">
                                        <el-option v-for="item in classOptions" :key="item.value"
                                            :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="学生" required>
                                    <el-select v-model="reportForm.studentId" filterable placeholder="请选择学生"
                                        :loading="studentLoading" :disabled="!reportForm.classId">
                                        <el-option v-for="item in studentOptions" :key="item.Id"
                                            :label="item.Name || item.StuName || item.stuName || item.name"
                                            :value="item.Id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <div class="ser-form-block">
                        <div class="ser-form-block__head">
                            评价周期
                            <span class="ser-form-block__hint">学期/周次快捷填充，也可自定义日期</span>
                        </div>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="学期">
                                    <el-select v-model="reportForm.semesterId" placeholder="选择学期"
                                        :loading="semesterLoading" @change="handleReportSemesterChange">
                                        <el-option v-for="item in semesterList" :key="item.Id"
                                            :label="item.SemesterName" :value="item.Id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="16">
                                <el-form-item label="周次">
                                    <el-select v-model="reportForm.week" placeholder="选择周次" clearable
                                        class="toolbar-field-w-week"
                                        :disabled="!reportForm.classId || !reportForm.semesterId"
                                        :loading="weekLoading" @change="handleReportWeekChange">
                                        <el-option v-for="item in reportWeeksOptions" :key="item.value"
                                            :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="日期范围" required class="ser-form-item--full">
                                    <el-date-picker v-model="reportForm.periodRange" type="daterange"
                                        start-placeholder="开始日期" end-placeholder="结束日期"
                                        value-format="yyyy-MM-dd" @change="onReportPeriodRangeChange"></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <div class="ser-form-block">
                        <div class="ser-form-block__head">导出格式</div>
                        <el-form-item label="文件类型" class="ser-form-item--full">
                            <el-radio-group v-model="reportForm.exportFormat" size="small">
                                <el-radio :label="0">Word</el-radio>
                                <el-radio :label="1">PDF</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </el-form>
            </div>

            <div slot="footer" class="ser-dialog-footer">
                <el-button size="small" @click="reportDialogVisible = false">取消</el-button>
                <el-button size="small" type="primary" plain icon="el-icon-view"
                    @click="handleOpenReportView">查看报告</el-button>
                <el-button class="ser-submit-export-btn" size="small" type="primary" icon="el-icon-document"
                    :loading="reportExportLoading" @click="handleSubmitExport">{{ reportSubmitButtonText }}</el-button>
            </div>
        </el-dialog>

        <!-- 查看报告弹窗（叠在生成弹窗之上，关闭后仍回到生成弹窗） -->
        <el-dialog :visible.sync="reportViewVisible" width="780px" top="4vh"
            custom-class="ser-view-dialog" :close-on-click-modal="false" append-to-body
            @opened="onReportViewOpened" @closed="onReportViewClosed">
            <div slot="title" class="ser-dialog-title ser-dialog-title--with-action">
                <span class="ser-dialog-title__icon"><i class="el-icon-data-analysis"></i></span>
                <div class="ser-dialog-title__text">
                    <span class="ser-dialog-title__main">学生评价报告</span>
                    <span class="ser-dialog-title__sub">点评分布、趋势、统计与点评记录</span>
                </div>
                <el-tooltip :content="reportViewDownloadTip" placement="bottom" :disabled="reportViewCanDownload">
                    <span class="ser-view-download-wrap">
                        <el-button type="text" icon="el-icon-download"
                            class="ser-view-download-btn"
                            :loading="reportViewDownloadLoading"
                            :disabled="!reportViewCanDownload"
                            @click="handleReportViewDownload">下载</el-button>
                    </span>
                </el-tooltip>
            </div>
            <StudentEvaluationReportView
                v-if="reportViewVisible"
                ref="reportView"
                :student-id="reportViewParams.studentId"
                :start-time="reportViewParams.startTime"
                :end-time="reportViewParams.endTime"
                :department-id="reportViewParams.departmentId"
                :student-name="reportViewParams.studentName"
                :show-header="false"
            />
        </el-dialog>
    </section>
</template>

<script>
import util from "../../../util/date";
import { getStudentEvaluationReportExportPage, downloadStudentEvaluationReportExportAdmin, batchDeleteStudentEvaluationReportExports, submitStudentEvaluationReportExportAdmin, getStudentSelectList } from '../../api/modules/personnel';
import { getSubDepartmentList } from '../../api/modules/department';
import { getSemesterList, getSemesterWeeksByClassId } from '../../api/modules/misc';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import DepartmentPane from '../../components/DepartmentPane';
import StudentEvaluationReportView from './StudentEvaluationReportView.vue';
import { normalizeDeptId, treeNodeDeptId, toDeptId } from '../../utils/deptCascaderProps';

export default {
    components: { DepartmentPane, StudentEvaluationReportView },
    data() {
        return {
            buttonList: [],
            loading: false,
            departmentId: 0,
            treeNodeData: null,
            filters: {
                studentName: '',
                teacherName: '',
                fileName: '',
                status: null,
                createTimeRange: null
            },
            list: [],
            page: 1,
            pageSize: 20,
            total: 0,
            multipleSelection: [],
            reportDialogVisible: false,
            reportDialogTitle: '生成学生评价报告',
            reportForm: {
                classId: null,
                studentId: null,
                semesterId: null,
                week: '',
                periodRange: null,
                exportFormat: 0
            },
            semesterList: [],
            semesterLoading: false,
            reportWeeksData: [],
            reportWeeksOptions: [],
            weekLoading: false,
            reportPeriodSyncLock: false,
            classOptions: [],
            classLoading: false,
            studentOptions: [],
            studentLoading: false,
            reportExportLoading: false,
            currentTeacherId: 0,
            reportViewVisible: false,
            reportViewDownloadLoading: false,
            reportViewParams: {
                studentId: null,
                startTime: '',
                endTime: '',
                departmentId: 0,
                studentName: '',
                exportId: null,
                canDownload: false
            },
            /** 生成中任务轮询定时器 */
            listPollTimer: null
        };
    },
    computed: {
        reportViewCanDownload() {
            return !!(this.reportViewParams && this.reportViewParams.exportId && this.reportViewParams.canDownload);
        },
        reportViewDownloadTip() {
            if (!this.reportViewParams || !this.reportViewParams.exportId) {
                return '请先生成报告，生成完成后再下载';
            }
            if (!this.reportViewParams.canDownload) {
                return '文件尚未生成完成';
            }
            return '';
        },
        reportSubmitButtonText() {
            return Number(this.reportForm.exportFormat) === 1 ? '生成 PDF' : '生成 Word';
        }
    },
    methods: {
        resolveCurrentTeacherId() {
            try {
                const user = window.localStorage.user ? JSON.parse(window.localStorage.user) : null;
                if (!user) return 0;
                const id = user.TeacherMasterId || user.teacherMasterId || user.uID || user.uId || user.id || user.ID;
                return id ? Number(id) : 0;
            } catch (e) {
                return 0;
            }
        },
        defaultPeriodRange() {
            const end = new Date();
            const start = new Date(end.getFullYear(), end.getMonth(), 1);
            return [
                util.formatDate.format(start, 'yyyy-MM-dd'),
                util.formatDate.format(end, 'yyyy-MM-dd')
            ];
        },
        getDeptOrgType(dept) {
            if (!dept) return '';
            return String(dept.DeptOrgType != null ? dept.DeptOrgType : dept.deptOrgType || '').toLowerCase();
        },
        getDeptId(dept) {
            if (!dept) return '';
            return treeNodeDeptId(dept);
        },
        getDeptName(dept) {
            if (!dept) return '';
            return dept.Name || dept.name || dept.label || '';
        },
        treeNodeClick(data) {
            this.departmentId = treeNodeDeptId(data);
            this.treeNodeData = data;
            this.page = 1;
            this.handleQuery();
        },
        loadReportClassOptions() {
            if (!this.departmentId) return Promise.resolve();
            this.classLoading = true;
            return getSubDepartmentList({ pid: this.departmentId }).then(res => {
                const result = (res && res.data) || res;
                const list = (result && result.response) || [];
                this.classOptions = (list || [])
                    .filter(d => this.getDeptOrgType(d) === 'class')
                    .map(d => ({
                        value: this.getDeptId(d),
                        label: this.getDeptName(d)
                    }));
            }).catch(() => {
                this.classOptions = [];
            }).finally(() => {
                this.classLoading = false;
            });
        },
        loadStudentOptions() {
            const classId = this.reportForm.classId;
            if (!classId) {
                this.studentOptions = [];
                return Promise.resolve();
            }
            this.studentLoading = true;
            return getStudentSelectList({ departmentId: classId }).then(res => {
                if (res && res.data && res.data.success) {
                    this.studentOptions = res.data.response || [];
                } else {
                    this.studentOptions = [];
                }
            }).catch(() => {
                this.studentOptions = [];
            }).finally(() => {
                this.studentLoading = false;
            });
        },
        loadReportSemesters() {
            if (!this.departmentId) return Promise.resolve();
            this.semesterLoading = true;
            return getSemesterList({ departmentId: this.departmentId }).then(res => {
                if (res && res.success && res.response && res.response.length) {
                    this.semesterList = res.response;
                    const current = this.semesterList.find(s => s.IsCurrent === 1 || s.IsCurrent === true)
                        || this.semesterList[0];
                    this.reportForm.semesterId = current ? current.Id : null;
                } else {
                    this.semesterList = [];
                    this.reportForm.semesterId = null;
                }
            }).catch(() => {
                this.semesterList = [];
                this.reportForm.semesterId = null;
            }).finally(() => {
                this.semesterLoading = false;
            });
        },
        getWeekDateRange(weekNum) {
            if (!weekNum || !this.reportWeeksData.length) return null;
            const wobj = this.reportWeeksData.find(x => x.WeekNumber === weekNum);
            if (!wobj || !Array.isArray(wobj.Days) || !wobj.Days.length) return null;
            return [
                String(wobj.Days[0].Date || '').split(' ')[0],
                String(wobj.Days[wobj.Days.length - 1].Date || '').split(' ')[0]
            ];
        },
        loadReportWeeks(classId, semesterId, keepWeek = false, preservePeriodRange = false) {
            if (!classId || !semesterId) {
                this.reportWeeksData = [];
                this.reportWeeksOptions = [];
                if (!keepWeek && !preservePeriodRange) this.reportForm.week = '';
                return Promise.resolve();
            }
            this.weekLoading = true;
            this.reportWeeksOptions = [];
            if (!keepWeek && !preservePeriodRange) this.reportForm.week = '';
            return getSemesterWeeksByClassId({
                departmentId: classId,
                semesterId: semesterId
            }).then(res => {
                if (res && res.data && res.data.success) {
                    const resp = res.data.response || [];
                    this.reportWeeksData = resp;
                    this.reportWeeksOptions = resp.map(w => {
                        let firstDate = '';
                        let lastDate = '';
                        if (Array.isArray(w.Days) && w.Days.length) {
                            firstDate = String(w.Days[0].Date || '').split(' ')[0];
                            lastDate = String(w.Days[w.Days.length - 1].Date || '').split(' ')[0];
                        }
                        const label = (firstDate && lastDate)
                            ? `第${w.WeekNumber}周 (${firstDate} ~ ${lastDate})`
                            : `第${w.WeekNumber}周`;
                        return { label, value: w.WeekNumber };
                    });

                    if (preservePeriodRange) return;

                    if (keepWeek && this.reportForm.week) {
                        this.handleReportWeekChange(this.reportForm.week);
                        return;
                    }

                    const now = new Date();
                    const todayStr = util.formatDate.format(now, 'yyyy-MM-dd');
                    let defaultWeekNum = null;
                    for (const w of resp) {
                        if (Array.isArray(w.Days) && w.Days.find(day => String(day.Date || '').split(' ')[0] === todayStr)) {
                            defaultWeekNum = w.WeekNumber;
                            break;
                        }
                    }
                    if (defaultWeekNum === null && this.reportWeeksOptions.length) {
                        defaultWeekNum = this.reportWeeksOptions[0].value;
                    }
                    if (defaultWeekNum !== null) {
                        this.reportForm.week = defaultWeekNum;
                        this.handleReportWeekChange(defaultWeekNum);
                    } else if (!this.reportForm.periodRange) {
                        this.reportForm.periodRange = this.defaultPeriodRange();
                    }
                } else {
                    this.reportWeeksData = [];
                    this.reportWeeksOptions = [];
                    if (!preservePeriodRange) {
                        this.reportForm.week = '';
                        if (!this.reportForm.periodRange) {
                            this.reportForm.periodRange = this.defaultPeriodRange();
                        }
                    }
                }
            }).catch(() => {
                this.reportWeeksData = [];
                this.reportWeeksOptions = [];
                if (!preservePeriodRange) {
                    this.reportForm.week = '';
                    if (!this.reportForm.periodRange) {
                        this.reportForm.periodRange = this.defaultPeriodRange();
                    }
                }
            }).finally(() => {
                this.weekLoading = false;
            });
        },
        initReportPeriodCascade(options = {}) {
            const preservePeriodRange = !!options.preservePeriodRange;
            return this.loadReportSemesters().then(() => {
                if (this.reportForm.classId && this.reportForm.semesterId) {
                    return this.loadReportWeeks(
                        this.reportForm.classId,
                        this.reportForm.semesterId,
                        false,
                        preservePeriodRange
                    );
                }
                if (!preservePeriodRange && !this.reportForm.periodRange) {
                    this.reportForm.periodRange = this.defaultPeriodRange();
                }
            });
        },
        handleReportSemesterChange() {
            if (this.reportForm.classId) {
                this.loadReportWeeks(this.reportForm.classId, this.reportForm.semesterId);
            } else {
                this.reportWeeksData = [];
                this.reportWeeksOptions = [];
                this.reportForm.week = '';
            }
        },
        handleReportWeekChange(val) {
            if (!val) return;
            const range = this.getWeekDateRange(val);
            if (!range) return;
            this.reportPeriodSyncLock = true;
            this.reportForm.periodRange = range;
            this.$nextTick(() => {
                this.reportPeriodSyncLock = false;
            });
        },
        onReportPeriodRangeChange(val) {
            if (this.reportPeriodSyncLock) return;
            if (!this.reportForm.week) return;
            const range = this.getWeekDateRange(this.reportForm.week);
            if (!range || !val || val.length !== 2 || val[0] !== range[0] || val[1] !== range[1]) {
                this.reportForm.week = '';
            }
        },
        resolveDefaultClassId() {
            if (!this.treeNodeData) return null;
            if (this.getDeptOrgType(this.treeNodeData) === 'class') {
                return this.getDeptId(this.treeNodeData);
            }
            return null;
        },
        openReportDialog() {
            if (!this.departmentId) {
                this.$message.warning('请先在左侧选择学校/校区');
                return;
            }
            this.reportDialogTitle = '生成学生评价报告';
            this.reportForm.classId = this.resolveDefaultClassId();
            this.reportForm.studentId = null;
            this.reportForm.semesterId = null;
            this.reportForm.week = '';
            this.reportForm.periodRange = null;
            this.studentOptions = [];
            this.reportWeeksData = [];
            this.reportWeeksOptions = [];
            this.reportDialogVisible = true;
            this.loadReportClassOptions().then(() => {
                return this.initReportPeriodCascade().then(() => {
                    if (this.reportForm.classId) {
                        return this.loadStudentOptions();
                    }
                });
            });
        },
        /** 打开完整报告查看弹窗（分布/趋势/统计/点评记录） */
        openReportView(params) {
            this.reportViewParams = {
                studentId: params.studentId,
                startTime: params.startTime,
                endTime: params.endTime,
                departmentId: params.departmentId || 0,
                studentName: params.studentName || '',
                exportId: params.exportId || null,
                canDownload: !!params.canDownload
            };
            // 不关闭「生成」弹窗：先查看，关闭后仍可生成 Word
            this.reportViewVisible = true;
        },
        onReportViewOpened() {
            this.$nextTick(() => {
                if (this.$refs.reportView && this.$refs.reportView.handleResize) {
                    this.$refs.reportView.handleResize();
                }
            });
        },
        onReportViewClosed() {
            this.reportViewDownloadLoading = false;
            this.reportViewParams = {
                studentId: null,
                startTime: '',
                endTime: '',
                departmentId: 0,
                studentName: '',
                exportId: null,
                canDownload: false
            };
        },
        openReportViewFromRow(row) {
            if (!row) return;
            this.openReportView({
                studentId: row.StudentId ? Number(row.StudentId) : null,
                startTime: this.formatDate(row.StartTime),
                endTime: this.formatDate(row.EndTime),
                departmentId: toDeptId(row.DepartmentId) || '',
                studentName: row.StudentName || '',
                exportId: row.Id,
                canDownload: !!row.CanDownload
            });
        },
        handleReportViewDownload() {
            if (!this.reportViewCanDownload) {
                this.$message.warning(this.reportViewDownloadTip || '暂不可下载');
                return;
            }
            this.reportViewDownloadLoading = true;
            this.handleDownload({
                Id: this.reportViewParams.exportId,
                CanDownload: true
            }).finally(() => {
                this.reportViewDownloadLoading = false;
            });
        },
        resolveStudentNameById(studentId) {
            const hit = (this.studentOptions || []).find(s => Number(s.Id) === Number(studentId));
            if (!hit) return '';
            return hit.Name || hit.StuName || hit.stuName || hit.name || '';
        },
        handleOpenReportView() {
            if (!this.validateReportForm()) return;
            this.openReportView({
                studentId: this.reportForm.studentId,
                startTime: this.reportForm.periodRange[0],
                endTime: this.reportForm.periodRange[1],
                departmentId: this.reportForm.classId,
                studentName: this.resolveStudentNameById(this.reportForm.studentId)
            });
        },
        onReportClassChange() {
            this.reportForm.studentId = null;
            if (this.reportForm.classId && this.reportForm.semesterId) {
                this.loadReportWeeks(this.reportForm.classId, this.reportForm.semesterId);
            } else {
                this.reportWeeksData = [];
                this.reportWeeksOptions = [];
                this.reportForm.week = '';
            }
            this.loadStudentOptions();
        },
        resetReportDialog() {
            this.reportForm.classId = null;
            this.reportForm.studentId = null;
            this.reportForm.semesterId = null;
            this.reportForm.week = '';
            this.reportForm.periodRange = null;
            this.reportForm.exportFormat = 0;
            this.semesterList = [];
            this.reportWeeksData = [];
            this.reportWeeksOptions = [];
            this.classOptions = [];
            this.studentOptions = [];
            this.reportExportLoading = false;
        },
        validateReportForm() {
            if (!this.departmentId) {
                this.$message.warning('请先在左侧选择学校/校区');
                return false;
            }
            if (!this.reportForm.classId) {
                this.$message.warning('请选择班级');
                return false;
            }
            if (!this.reportForm.studentId) {
                this.$message.warning('请选择学生');
                return false;
            }
            if (!this.reportForm.periodRange || this.reportForm.periodRange.length !== 2) {
                this.$message.warning('请选择评价周期');
                return false;
            }
            return true;
        },
        handleSubmitExport() {
            if (!this.validateReportForm()) return;
            const teacherId = this.currentTeacherId || this.resolveCurrentTeacherId();
            if (!teacherId) {
                this.$message.warning('无法识别当前登录用户，无法提交生成');
                return;
            }
            this.reportExportLoading = true;
            submitStudentEvaluationReportExportAdmin({
                departmentId: this.departmentId,
                studentId: this.reportForm.studentId,
                startTime: this.reportForm.periodRange[0] + 'T00:00:00',
                endTime: this.reportForm.periodRange[1] + 'T23:59:59',
                teacherId: teacherId,
                exportFormat: this.reportForm.exportFormat || 0
            }).then(res => {
                if (res && res.data && res.data.success) {
                    this.$message.success(res.data.msg || '已提交生成');
                    this.reportDialogVisible = false;
                    this.handleQuery();
                    this.startListPoll();
                } else {
                    this.$message.error((res && res.data && res.data.msg) || '提交生成失败');
                }
            }).catch(() => {
                this.$message.error('提交生成出错');
            }).finally(() => {
                this.reportExportLoading = false;
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val || [];
        },
        handleQuery() {
            this.page = 1;
            this.loadList(1);
        },
        /** 当前页是否存在待处理/生成中任务 */
        hasGeneratingInList() {
            return (this.list || []).some(row => row.Status === 0 || row.Status === 1);
        },
        /** 有生成中任务时轮询列表，直到全部结束 */
        startListPoll() {
            this.stopListPoll();
            this.listPollTimer = setInterval(() => {
                if (!this.departmentId) {
                    this.stopListPoll();
                    return;
                }
                this.loadList(this.page || 1, true);
            }, 3000);
        },
        stopListPoll() {
            if (this.listPollTimer) {
                clearInterval(this.listPollTimer);
                this.listPollTimer = null;
            }
        },
        syncListPoll() {
            if (this.hasGeneratingInList()) {
                if (!this.listPollTimer) this.startListPoll();
            } else {
                this.stopListPoll();
            }
        },
        loadList(page = 1, silent = false) {
            if (!this.departmentId) {
                if (!silent) this.$message.warning('请选择学校/校区');
                return;
            }
            if (!silent) this.loading = true;
            const params = {
                departmentId: this.departmentId,
                studentName: this.filters.studentName || '',
                teacherName: this.filters.teacherName || '',
                fileName: this.filters.fileName || '',
                page: page,
                pageSize: this.pageSize
            };
            if (this.filters.status !== null && this.filters.status !== undefined && this.filters.status !== '') {
                params.status = this.filters.status;
            }
            if (this.filters.createTimeRange && this.filters.createTimeRange.length === 2) {
                params.createTimeFrom = this.filters.createTimeRange[0];
                params.createTimeTo = this.filters.createTimeRange[1];
            }
            getStudentEvaluationReportExportPage(params).then(res => {
                if (res && res.data && res.data.success) {
                    const resp = res.data.response || {};
                    this.list = resp.data || [];
                    this.total = resp.dataCount || 0;
                    this.page = resp.page || page;
                    this.pageSize = resp.PageSize || this.pageSize;
                    this.syncListPoll();
                } else if (!silent) {
                    this.$message.error((res && res.data && res.data.msg) || '获取生成记录失败');
                }
            }).catch(() => {
                if (!silent) this.$message.error('获取生成记录出错');
            }).finally(() => {
                if (!silent) this.loading = false;
            });
        },
        handleDownload(row) {
            if (!row || !row.Id) {
                return Promise.resolve();
            }
            if (!row.CanDownload) {
                this.$message.warning('文件尚未生成完成');
                return Promise.resolve();
            }
            return downloadStudentEvaluationReportExportAdmin({
                id: row.Id,
                departmentId: this.departmentId
            }).then(res => {
                if (!res || !res.data || !res.data.success) {
                    this.$message.error((res && res.data && res.data.msg) || '获取下载地址失败');
                    return;
                }
                const data = res.data.response || {};
                let url = data.DownloadUrl || data.downloadUrl || '';
                if (!url) {
                    this.$message.error('下载地址为空');
                    return;
                }
                if (url.startsWith('/')) {
                    url = (BaseApiUrl || '').replace(/\/$/, '') + url;
                }
                window.open(url, '_blank');
            }).catch(() => {
                this.$message.error('下载请求出错');
            });
        },
        handleDel() {
            if (!this.multipleSelection.length) {
                this.$message.warning('请选择要删除的记录');
                return;
            }
            this.confirmDeleteExports(this.multipleSelection.map(x => x.Id),
                `确认删除选中的 ${this.multipleSelection.length} 条记录吗？（含物理文件）`);
        },
        /** 行内删除单条生成记录 */
        handleDelRow(row) {
            if (!row || !row.Id) return;
            const tipName = row.FileName || row.StudentName || '该记录';
            this.confirmDeleteExports([row.Id], `确认删除「${tipName}」吗？（含物理文件）`);
        },
        confirmDeleteExports(ids, message) {
            if (!ids || !ids.length) return;
            this.$confirm(message, '提示', { type: 'warning' }).then(() => {
                this.loading = true;
                batchDeleteStudentEvaluationReportExports({
                    ids: ids,
                    departmentId: this.departmentId
                }).then(res => {
                    if (res && res.data && res.data.success) {
                        this.$message.success(res.data.msg || '删除成功');
                        this.handleQuery();
                    } else {
                        this.$message.error((res && res.data && res.data.msg) || '删除失败');
                    }
                }).catch(() => {
                    this.$message.error('删除请求出错');
                }).finally(() => {
                    this.loading = false;
                });
            }).catch(() => { });
        },
        formatDate(val) {
            if (!val) return '';
            return util.formatDate.format(new Date(val), 'yyyy-MM-dd');
        },
        formatDateTime(val) {
            if (!val) return '';
            return util.formatDate.format(new Date(val), 'yyyy-MM-dd hh:mm:ss');
        },
        statusText(status) {
            const map = { 0: '待处理', 1: '生成中', 2: '已生成', 3: '失败' };
            return map[status] || '未知';
        },
        statusTagType(status) {
            const map = { 0: 'info', 1: 'warning', 2: 'success', 3: 'danger' };
            return map[status] || 'info';
        },
        storageTypeText(storageType) {
            return storageType === 1 ? 'OSS' : '本机';
        }
    },
    mounted() {
        const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
        this.buttonList = getButtonList(this.$route.path, routers);
        this.currentTeacherId = this.resolveCurrentTeacherId();
    },
    beforeDestroy() {
        this.stopListPoll();
    }
};
</script>

<style scoped>
.page-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.page-head__info {
    display: flex;
    align-items: baseline;
    gap: 12px;
    min-width: 0;
}

.page-head__title {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
}

.page-head__desc {
    font-size: 13px;
    color: #909399;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.pagination-wrap {
    margin-top: 12px;
    text-align: right;
}

.pagination-wrap ::v-deep .el-pagination {
    display: inline-flex;
    width: auto;
    margin: 0;
    padding: 0;
    background: transparent;
    box-shadow: none;
}

.ser-op-del {
    color: #f56c6c;
}

.ser-op-del:hover,
.ser-op-del:focus {
    color: #f78989;
}
</style>

<!-- 弹窗样式（teleport 到 body，不可 scoped） -->
<style>
.ser-report-dialog {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 20px 48px rgba(15, 23, 42, 0.12);
}

.ser-report-dialog .el-dialog__header {
    padding: 20px 24px 16px;
    border-bottom: none;
    background: #fff;
}

.ser-report-dialog .el-dialog__headerbtn {
    top: 18px;
    right: 18px;
}

.ser-report-dialog .el-dialog__body {
    padding: 0 24px 20px;
    max-height: 68vh;
    overflow-x: hidden;
    overflow-y: auto;
}

.ser-report-dialog .el-dialog__footer {
    padding: 12px 24px 20px;
    border-top: 1px solid #eef2f6;
    background: #fff;
}

/* 标题 */
.ser-dialog-title {
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.ser-dialog-title--with-action {
    position: relative;
    align-items: center;
    padding-right: 88px;
    width: 100%;
    box-sizing: border-box;
}

.ser-dialog-title--with-action .ser-dialog-title__text {
    flex: 1;
    min-width: 0;
}

.ser-view-download-wrap {
    position: absolute;
    top: 50%;
    right: 40px;
    transform: translateY(-50%);
    z-index: 1;
}

.ser-view-download-btn {
    padding: 0 4px;
    font-size: 14px;
    color: #059669;
}

.ser-view-download-btn.is-disabled {
    color: #c0c4cc;
}

.ser-view-download-btn:hover:not(.is-disabled) {
    color: #047857;
}

.ser-dialog-title__icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: linear-gradient(135deg, #ecfdf5, #d1fae5);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.ser-dialog-title__icon i {
    font-size: 20px;
    color: #059669;
}

.ser-dialog-title__text {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-top: 2px;
}

.ser-dialog-title__main {
    font-size: 16px;
    font-weight: 600;
    color: #0f172a;
    line-height: 1.3;
}

.ser-dialog-title__sub {
    font-size: 12px;
    color: #94a3b8;
    font-weight: 400;
    line-height: 1.4;
}

/* 表单区块 */
.ser-dialog-body {
    padding-top: 4px;
}

.ser-form-block {
    background: #f8fafc;
    border: 1px solid #eef2f6;
    border-radius: 10px;
    padding: 14px 16px 6px;
    margin-bottom: 12px;
}

.ser-form-block--preview {
    background: #fff;
    border-color: #e2e8f0;
    padding-bottom: 14px;
}

.ser-form-block__head {
    font-size: 13px;
    font-weight: 600;
    color: #334155;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

.ser-form-block__hint {
    font-size: 12px;
    font-weight: 400;
    color: #94a3b8;
}

.ser-dialog-form .el-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
}

.ser-dialog-form .el-col {
    padding-left: 10px !important;
    padding-right: 10px !important;
}

.ser-dialog-form .el-form-item {
    margin-bottom: 12px;
}

.ser-dialog-form .el-form-item__label {
    color: #64748b;
    font-weight: 400;
    line-height: 32px;
    padding-right: 8px;
}

.ser-dialog-form .el-select,
.ser-dialog-form .el-date-editor {
    width: 100%;
}

.ser-form-item--full .el-form-item__content {
    line-height: normal;
}

.ser-form-item--full .el-date-editor {
    width: 100% !important;
}

/* 预览 */
.ser-preview-basic {
    margin: 0 0 12px;
    font-size: 13px;
    color: #475569;
    line-height: 1.5;
}

.ser-preview-stats {
    display: flex;
    gap: 10px;
    margin-bottom: 12px;
}

.ser-stat {
    flex: 1;
    display: flex;
    align-items: baseline;
    gap: 4px;
    padding: 10px 14px;
    border-radius: 8px;
    background: #fff;
    border: 1px solid #e2e8f0;
}

.ser-stat--praise {
    border-color: #bbf7d0;
    background: #f0fdf4;
}

.ser-stat--improve {
    border-color: #fecaca;
    background: #fef2f2;
}

.ser-stat__label {
    font-size: 12px;
    color: #64748b;
}

.ser-stat__value {
    font-size: 20px;
    font-weight: 700;
    line-height: 1;
}

.ser-stat--praise .ser-stat__value {
    color: #059669;
}

.ser-stat--improve .ser-stat__value {
    color: #dc2626;
}

.ser-stat__unit {
    font-size: 12px;
    color: #94a3b8;
}

.ser-preview-table {
    border-radius: 6px;
    border: 1px solid #eef2f6;
}

.ser-preview-table th {
    background: #f8fafc !important;
    color: #64748b;
    font-weight: 500;
}

.ser-preview-table::before {
    height: 0;
}

/* 底部按钮 */
.ser-dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}

.ser-dialog-footer .el-button {
    border-radius: 6px;
    min-width: 88px;
}

/* 按「生成 Word」宽度固定，切换 PDF 时按钮不缩短 */
.ser-dialog-footer .ser-submit-export-btn {
    min-width: 112px;
}

@media (max-width: 768px) {
    .ser-report-dialog {
        width: 92vw !important;
    }

    .ser-preview-stats {
        flex-direction: column;
    }
}

.ser-view-dialog {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 20px 48px rgba(15, 23, 42, 0.12);
}

.ser-view-dialog .el-dialog__header {
    padding: 18px 24px 12px;
    border-bottom: none;
    position: relative;
}

.ser-view-dialog .el-dialog__headerbtn {
    top: 20px;
    right: 18px;
    z-index: 2;
}

.ser-view-dialog .el-dialog__body {
    padding: 0 20px 20px;
    max-height: 78vh;
    overflow-x: hidden;
    overflow-y: auto;
}

@media (max-width: 992px) {
    .ser-view-dialog {
        width: 94vw !important;
    }
}
</style>
